import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useAttachmentsPermissions } from '../../../Attachments.permissions';
import { IRenameAttachmentBl } from '../../RenameAttachment.bl';

interface IProps {
  id: string;
  name: string;
  parentId: string;
}

export const RenameAttachmentIconedButtonContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(IRenameAttachmentBl.$);
  const permissions = useAttachmentsPermissions();
  const canRename = permissions.canRenameAttachment();

  const handleClick = (): void => {
    bl.initialize(props.id, props.name, props.parentId);
    bl.showModal();
  };

  return (
    <IconButton
      onClick={handleClick}
      color='primary'
      size='sm'
      title={canRename.reason}
      disabled={!canRename.allowed}
    >
      <FontAwesomeIcon icon={faEdit} />
    </IconButton>
  );
});
